import type { ReactNode } from "react";
import { Card as RadixCard } from "@radix-ui/themes";
import { cn } from "../../lib/utils";

interface CardProps {
  children: ReactNode;
  className?: string;
  size?: "1" | "2" | "3" | "4";
  variant?: "surface" | "classic";
  asChild?: boolean;
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDragLeave?: () => void;
  onDrop?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
  onClick?: () => void;
}

export const Card = ({ 
  children, 
  className, 
  size = "4", 
  variant = "surface",
  asChild = false,
  draggable,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
  onClick
}: CardProps) => {
  return (
    <RadixCard 
      size={size} 
      variant={variant} 
      asChild={asChild}
      className={cn("!p-6", className)}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      onClick={onClick}
    >
      {children}
    </RadixCard>
  );
}; 